import { useCallback, useState } from 'react';
import ClassInfoSettings from './ClassInfoSettings';
import NotificationSettings from './NotificationSettings';
import ActivitySettings from './Subsettings/ActivitySettings';
import Section from './Sections/Section';
import Instructors from './Instructors.js/Instructors';
import { ModalPortal } from '../../../ModalPortal';
import { CustomModal } from '../../../../shared/CustomModal';
import './settings.css';
import { useDispatch } from 'react-redux';
import { addInstructor, addSection } from '../../../../Store/api/classApi';
import { toast } from 'react-toastify';
import { CustomSelect } from '../../../../shared/CustomSelect';
import ArrowRight from '../../../../assets/images/Arrow-right-dark.svg';
const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  marginBottom: 8,
  marginTop: 8,
  width: 0,
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const modalVeriations = {
  instructors: {
    title: 'add new instructor to class',
    actionBtnText: 'Add instructor',
  },
  sections: {
    title: 'add new section to class',
    actionBtnText: 'Add section',
  },
};

const Settings = ({ classId, setRefetch, classSettings, classSections, setClassDetail, setClassSettingProperties }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [instructorSection, setInstructorSection] = useState({});
  const [section, setSection] = useState({
    name: '',
    section_number: '',
    email: '',
  });
  // const [error, setError] = useState({
  //   name: "",
  //   section_number: "",
  //   email: ""
  // });
  const [instructor, setInstructor] = useState('');
  const [settingMode, setSettingMode] = useState('sections');

  const onToggle = useCallback(() => {
    setShowModal((prev) => !prev);
    setSection({
      name: '',
      section_number: '',
      email: '',
    });
    setInstructor('');
    setInstructorSection({});
  }, []);

  const handleChange = (e) => {
    if (settingMode === 'sections') {
      setSection((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    } else if (settingMode === 'instructors') {
      setInstructor(e.target.value);
    }
  };

  const APICall = () => {
    if (settingMode === 'sections' && !section.name) {
      toast.error('Section name required');
      // setError(prev => ({...prev, name: 'Section name required'}));
      return;
    } else if (settingMode === 'sections' && !section.section_number) {
      toast.error('Section number required');
      // setError(prev => ({...prev, section_number: 'Section number required'}));
      return;
    } else if (settingMode === 'instructors' && !instructorSection?.value) {
      toast.error('Section required');
      return;
    } else if (settingMode === 'instructors' && !instructor) {
      toast.error('Instructor email required');
      return;
    }

    setLoading(true);
    if (settingMode === 'sections')
      dispatch(
        addSection({
          body: {
            classId,
            sectionName: section.name,
            instructorEmails: [section.email],
            sectionNumber: section.section_number,
          },
          onSuccess: () => {
            setRefetch(true);
            toast.success('Section added successfully.');
          },
          onError: () => {
            toast.error('Error while adding new section in class.');
          },
          onEnd: () => {
            setLoading(false);
            setSection({
              name: '',
              section_number: '',
              email: '',
            });
            setShowModal(false);
          },
        })
      );
    else if (settingMode === 'instructors')
      dispatch(
        addInstructor({
          body: {
            sectionId: instructorSection?.value,
            instructorEmails: [instructor],
          },
          onSuccess: () => {
            setRefetch(true);
            toast.success('Instructor added successfully.');
          },
          onError: () => {
            toast.error('Error while adding Instrcutor in class.');
          },
          onEnd: () => {
            setLoading(false);
            setSection({
              name: '',
              section_number: '',
              email: '',
            });
            setInstructor({});
            setShowModal(false);
          },
        })
      );
  };

  return (
    <>
      <ModalPortal>
        <CustomModal loading={loading} onHide={onToggle} showModal={showModal} onAction={APICall} cancelBtnText='Go back' {...modalVeriations[settingMode]}>
          <div className='d-flex flex-column gap-2 w-100'>
            {settingMode === 'sections' && (
              <div className='d-flex justify-content-between'>
                <div className='form-group mb-0 w-45'>
                  <input type='text' name='name' value={section.name} onChange={handleChange} className='form-control' placeholder='Section Name' />
                  {/* {error.name && <span className="error-msg-3">*Section name required</span>} */}
                </div>
                <div className='form-group mb-0 w-45'>
                  <input type='text' name='section_number' className='form-control' placeholder='Section Number' value={section.section_number} onChange={handleChange} />
                  {/* {error.section_number && <span className="error-msg-3">*Section number required</span>} */}
                </div>
              </div>
            )}
            {settingMode === 'instructors' && (
              <div className='d-flex justify-content-between align-items-center'>
                <div className='form-group mb-0 w-45'>
                  <input type='text' name='name' readonly className='form-control' placeholder='Section Name' value={classSections.filter((item) => item._id === instructorSection?.value)?.[0]?.sectionName || ''} />
                  {/* {error.name && <span className="error-msg-3">*Section name required</span>} */}
                </div>
                <div className='form-group mb-0 w-50'>
                  <CustomSelect
                    isClearable
                    customStyle={{
                      control: (base, state) => ({
                        ...base,
                        border: 'none !important',
                        background: '#fafaf9',
                        boxShadow: 'none',
                        borderBottom: state.isFocused ? '1px solid #2e2e2d !important' : '1px solid #2e2e2d !important',
                        '&:hover': {
                          borderBottom: '1px solid #2e2e2d', // Keep border on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        marginTop: 0, // This removes the gap between control and dropdown
                        border: "1px solid grey"
                      }),
                    }}
                    className='w-100 mb-0'
                    placeholder='Section Number'
                    value={classSections
                      .filter((item) => item._id === instructorSection?.value)
                      ?.map((item) => ({
                        label: `Section ${item.sectionNumber.split('-')?.[0]}`,
                        value: item._id,
                      }))}
                    options={classSections.map((item) => ({
                      label: `Section ${item.sectionNumber.split('-')?.[0]}`,
                      value: item._id,
                    }))}
                    handleChange={(value) => {
                      setInstructorSection(value);
                    }}
                    components={{ IndicatorSeparator }}
                  />
                </div>
              </div>
            )}
            <div className='form-group mb-0 w-100'>
              <input type='email' name='email' className='form-control mb-2' placeholder='Enter instructor email' onChange={handleChange} value={settingMode === 'sections' ? section.email : instructor} />
              <p className='mb-0 text_grey fs-12 fw-normal lh-normal fst-normal'>*We’ll send the instructor an email inviting them to join Greyled</p>
            </div>
          </div>
        </CustomModal>
      </ModalPortal>
      <div className='tab-pane fade show active' id='Contents' role='tabpanel' aria-labelledby='Contents-tab'>
        <div className='Contents_tabs'>
          <div className='tabs_content_settings'>
            <div className='top_settings'>
              <div className='top_left_settings'>
                <ClassInfoSettings settings={classSettings} classId={classId} />
                <NotificationSettings studentNot={classSettings.studentNotification} classId={classId} setClassSettingProperties={setClassSettingProperties} />
              </div>
              <div className='top_right_settings'>
                <ActivitySettings activitySettings={classSettings.activitySettings} classId={classId} setClassSettingProperties={setClassSettingProperties} />
              </div>
            </div>
            <div className='bottom_settings'>
              <div className='bottom_header'>
                <div className='b_header_left'>
                  <h1>{settingMode === 'sections' ? 'Section select' : 'instructor management'}</h1>
                  {settingMode === 'sections' && (
                    <div className='w-32 text-start'>
                      <CustomSelect
                        isClearable
                        className='w-100'
                        placeholder='Select Section'
                        isDisabled={!!(classSections.length === 1 || !classSections.length)}
                        customStyle={{
                          control: (base, state) => ({
                            ...base,
                            border: 'none !important',
                            background: '#fafaf9',
                            boxShadow: 'none',
                            borderBottom: state.isFocused ? '1px solid #2e2e2d !important' : '1px solid #2e2e2d !important',
                            '&:hover': {
                              borderBottom: '1px solid #2e2e2d', // Keep border on hover
                            },
                          }),
                          menu: (provided) => ({
                            ...provided,
                            marginTop: 0, // This removes the gap between control and dropdown
                            border: "1px solid grey"
                          }),
                        }}
                        value={classSections
                          .filter((item) => item._id === selected?.value)
                          ?.map((item) => ({
                            label: item.sectionName,
                            value: item._id,
                          }))}
                        options={classSections.map((item) => ({
                          label: item.sectionName,
                          value: item._id,
                        }))}
                        handleChange={(value) => {
                          setSelected(value);
                        }}
                        components={{ IndicatorSeparator }}
                      />
                    </div>
                  )}
                  <button className='cursor save-btn text-uppercase rounded-0 text-decoration-none' onClick={() => setShowModal(true)}>
                    {settingMode === 'sections' ? 'Add new section' : 'Add new Instructor'} <img src={ArrowRight} alt='save' />
                  </button>
                </div>
                <div className='b_header_right'>
                  Section Settings
                  <div className='switch_wrapper'>
                    <label className='switch'>
                      <input
                        type='checkbox'
                        checked={settingMode === 'instructors'}
                        onChange={(e) => {
                          setSettingMode(e.target.checked ? 'instructors' : 'sections');
                        }}
                      />
                      <span className='slider round'></span>
                    </label>
                  </div>
                  Instructor Management
                </div>
              </div>
              {settingMode === 'sections' ? (
                <div className='sections_wrapper'>
                  {classSections
                    .filter((item) => (selected?.value ? item._id === selected.value : item))
                    .map((section, index) => (
                      <Section key={index} index={index} section={section} classDetails={classSettings} setRefetch={setRefetch} />
                    ))}
                </div>
              ) : (
                <Instructors classDetails={classSettings} setRefetch={setRefetch} setClassDetail={setClassDetail} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
